import * as types from './actionTypes';
import rest from "../API/api";
import ReactDOM from "react-dom";
import sha1 from "sha1";

export function loadConsentsSuccess(consents) {
    //debugger;
    return {type: types.LOAD_CONSENT_SUCCESS, consents};
}

export function deleteConsentsSuccess(consents) {
    //debugger;
    return {type: types.DELETE_CONSENT_SUCCESS, consents};
}

export function updateConsentsSuccess(consents) {
    //debugger;
    return {type: types.UPDATE_CONSENT_SUCCESS, consents};
}

export function addConsentsSuccess(consents) {
    //debugger;
    return {type: types.ADD_CONSENT_SUCCESS, consents};
}

export function readConsentSuccess(consent) {
    //debugger;
    return {type: types.READ_CONSENT_SUCCESS, consent};
}


// Functions below handle asynchronous calls.
// Each returns a function that accepts a dispatch.
// These are used by redux-thunk to support asynchronous interactions.
export function loadConsents(tenant) {
    return function (dispatch) {
        //Build REST URL passing Tenant ID since Consents is a sub document type
        let tempURL = rest.consents + '/' + tenant._id;
        fetch(tempURL, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {

                //debugger;
                // turn the JSON into a string then into an JS array
                return dispatch(loadConsentsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}

//Makes an API call to the gateway which will update the consent with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the update so we will dispatch a store update with the new records.
export function updateConsent(tenant,consent) {
    return async function (dispatch) {
        //lets define some const. that we can use in the fetch calls below
        //REST API Gateway URLs
        //!!!!!MAKE SURE YOU USE THE SINGULAR "CONSENT" endpoint for Updates!!!!!
        let tempURL = rest.consent + '/' + consent._id;
        const cloudURL = tenant.cloudinary_upload;
        //Image file string that contains the Binary of the file we are storing in Cloudinary
        const imageFile = consent.TitleImage;
        //Flag as to whether the image changed from the EditCustomer form
        const imageChanged = consent.imageChanged;
        //Build some const. for signing the payload
        const timestamp = Date.now();
        const api_key = tenant.apiKeyCloudinary;
        const api_secret = tenant.apiSecretKeyCloudinary;
        //Current Tenant record that we will need to update
        const consentID = consent._id;
        let myPublicId = consent.TitleImagePublicId;
        let payload_to_sign = "";
        let myBody = {};
        if(imageChanged) {
            //If its empty then we need to create a new public ID and post the image
            if((myPublicId === "") || (!myPublicId)) {
                var crypto = require('crypto');
                //assign the Salt, generate the hash based on the password provided
                let mySalt = crypto.randomBytes(16).toString('hex');
                let myHash = crypto.pbkdf2Sync(consentID, mySalt, 1000, 16, 'sha512').toString('hex');
                payload_to_sign = "public_id=" + myHash + "&timestamp=" + timestamp + "&upload_preset=b2qvuoov" + api_secret;
                myPublicId = myHash;
                let sha1_hash = sha1(payload_to_sign);
                myBody= JSON.stringify({
                    api_key: api_key,
                    file: imageFile,
                    public_id:  myPublicId,
                    signature: sha1_hash,
                    timestamp: timestamp,
                    upload_preset: "b2qvuoov"
                })
            }
            //It already exists so lets update the image
            else {
                let payload_to_sign = "public_id=" + myPublicId + "&timestamp=" + timestamp + api_secret;
                let sha1_hash = sha1(payload_to_sign);
                myBody= JSON.stringify({
                    api_key: api_key,
                    file: imageFile,
                    public_id:  myPublicId,
                    signature: sha1_hash,
                    timestamp: timestamp,
                })
            }
            await fetch(cloudURL, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json;charset=UTF-8',
                }),
                body: myBody,
            })
                .then(response => response.json())
                .then(data => {
                    //Now lets update the customer record with any version or URL changes from Cloudinary
                    let tempURL = rest.consent + '/' + consent._id;
                    fetch(tempURL, {
                        method: 'PUT',
                        headers: new Headers({
                            'Content-Type': 'application/json;charset=UTF-8',
                            'x-api-key': tenant.apiKey
                        }),
                        body: JSON.stringify({
                            Enabled: consent.Enabled,
                            Name: consent.Name,
                            TitleImage: data.secure_url,
                            TitleImagePublicId: data.public_id,
                            Header: consent.Header,
                            AfterSubmit: consent.AfterSubmit,
                            Company: consent.Company,
                            EmailTo: consent.EmailTo,
                            EmailFrom: consent.EmailFrom,
                            EmailSubject: consent.EmailSubject,
                            EmailText: consent.EmailText,
                            EnableCamera: consent.EnableCamera,
                            PhotoRequired: consent.PhotoRequired,
                            AgeLimit: consent.AgeLimit,
                            AskRelation: consent.AskRelation,
                            EnableNotary: consent.EnableNotary,
                            ParentHeader: consent.ParentHeader,
                            ConsentFooter: consent.ConsentFooter,
                            RequireName: consent.RequireName,
                            RequireEmail: consent.RequireEmail,
                            RequireAddress: consent.RequireAddress,
                            RequirePhone: consent.RequirePhone,
                            RequireNationality: consent.RequireNationality,
                            RequireGender: consent.RequireGender,
                            IncludedArtists: consent.IncludedArtists,
                            IncludedClauses: consent.IncludedClauses
                        }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            // turn the JSON into a string then into an JS array
                            return dispatch(updateConsentsSuccess(JSON.parse(JSON.stringify(data))))
                        })
                        .catch(error => console.error(error));
                })
                .catch(error => console.error(error))
        }
        else {

            //Update the main MongoDB record
            await fetch(tempURL, {
                method: 'PUT',
                headers: new Headers({
                    'Content-Type': 'application/json;charset=UTF-8',
                    'x-api-key': tenant.apiKey
                }),
                body: JSON.stringify({
                    Enabled: consent.Enabled,
                    Name: consent.Name,
                    TitleImage: consent.TitleImage,
                    TitleImagePublicId: consent.TitleImagePublicId,
                    Header: consent.Header,
                    AfterSubmit: consent.AfterSubmit,
                    Company: consent.Company,
                    EmailTo: consent.EmailTo,
                    EmailFrom: consent.EmailFrom,
                    EmailSubject: consent.EmailSubject,
                    EmailText: consent.EmailText,
                    EnableCamera: consent.EnableCamera,
                    PhotoRequired: consent.PhotoRequired,
                    AgeLimit: consent.AgeLimit,
                    AskRelation: consent.AskRelation,
                    EnableNotary: consent.EnableNotary,
                    ParentHeader: consent.ParentHeader,
                    ConsentFooter: consent.ConsentFooter,
                    RequireName: consent.RequireName,
                    RequireEmail: consent.RequireEmail,
                    RequireAddress: consent.RequireAddress,
                    RequirePhone: consent.RequirePhone,
                    RequireNationality: consent.RequireNationality,
                    RequireGender: consent.RequireGender,
                    IncludedArtists: consent.IncludedArtists,
                    IncludedClauses: consent.IncludedClauses
                }),
            })
                .then(response => response.json())
                .then(data => {
                    //Check to see if the image was modified, if so overwrite the image with the same public id

                    // turn the JSON into a string then into an JS array
                    return dispatch(updateConsentsSuccess(JSON.parse(JSON.stringify(data))))
                })
                .catch(error => console.error(error));
        }
    };
}


//Makes an API call to the gateway which will add the consent under the tenant _id. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function addConsent(tenant,consent) {
    return function (dispatch) {
        const cloudURL = tenant.cloudinary_upload;
        const imageFile = consent.TitleImage;
        //Build some const. for signing the payload
        const timestamp = Date.now();
        const api_key = tenant.apiKeyCloudinary;
        const api_secret = tenant.apiSecretKeyCloudinary;
        var crypto = require('crypto');
        //assign the Salt, generate the hash based on the password provided
        let mySalt = crypto.randomBytes(16).toString('hex');
        let myHash = crypto.pbkdf2Sync(tenant._id, mySalt, 1000, 16, 'sha512').toString('hex');
        if(imageFile !== "") {
            let payload_to_sign = "public_id=" + myHash + "&timestamp=" + timestamp + "&upload_preset=b2qvuoov" + api_secret;
            let sha1_hash = sha1(payload_to_sign);
            fetch(cloudURL, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json;charset=UTF-8',
                }),
                body: JSON.stringify({
                    api_key: api_key,
                    file: imageFile,
                    public_id: myHash,
                    signature: sha1_hash,
                    timestamp: timestamp,
                    //this is the preset key for the directory I have setup in Cloudinary
                    upload_preset: "b2qvuoov"
                }),
            })
                .then(response => response.json())
                .then(data => {
                    //lets find the consent form id we just saved
                    let tempURL = rest.consents + '/' + tenant._id;
                    fetch(tempURL, {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json;charset=UTF-8',
                            'x-api-key': tenant.apiKey
                        }),
                        body: JSON.stringify({
                            Enabled: consent.Enabled,
                            Name: consent.Name,
                            TitleImage: data.secure_url,
                            TitleImagePublicId: data.public_id,
                            Header: consent.Header,
                            AfterSubmit: consent.AfterSubmit,
                            Company: consent.Company,
                            EmailTo: consent.EmailTo,
                            EmailFrom: consent.EmailFrom,
                            EmailSubject: consent.EmailSubject,
                            EmailText: consent.EmailText,
                            EnableCamera: consent.EnableCamera,
                            PhotoRequired: consent.PhotoRequired,
                            AgeLimit: consent.AgeLimit,
                            AskRelation: consent.AskRelation,
                            EnableNotary: consent.EnableNotary,
                            ParentHeader: consent.ParentHeader,
                            ConsentFooter: consent.ConsentFooter,
                            RequireName: consent.RequireName,
                            RequireEmail: consent.RequireEmail,
                            RequireAddress: consent.RequireAddress,
                            RequirePhone: consent.RequirePhone,
                            RequireNationality: consent.RequireNationality,
                            RequireGender: consent.RequireGender,
                            IncludedArtists: consent.IncludedArtists,
                            IncludedClauses: consent.IncludedClauses
                        }),
                    })
                        .then(response => response.json())
                        .then(data => {
                            return dispatch(addConsentsSuccess(JSON.parse(JSON.stringify(data))))
                        })
                        .catch(error => console.error(error));
                })
                .catch(error => console.error(error));
        }
        else {
            let tempURL = rest.consents + '/' + tenant._id;
            fetch(tempURL, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json;charset=UTF-8',
                    'x-api-key': tenant.apiKey
                }),
                body: JSON.stringify({
                    Enabled: consent.Enabled,
                    Name: consent.Name,
                    TitleImage: "",
                    TitleImagePublicId: "",
                    Header: consent.Header,
                    AfterSubmit: consent.AfterSubmit,
                    Company: consent.Company,
                    EmailTo: consent.EmailTo,
                    EmailFrom: consent.EmailFrom,
                    EmailSubject: consent.EmailSubject,
                    EmailText: consent.EmailText,
                    EnableCamera: consent.EnableCamera,
                    PhotoRequired: consent.PhotoRequired,
                    AgeLimit: consent.AgeLimit,
                    AskRelation: consent.AskRelation,
                    EnableNotary: consent.EnableNotary,
                    ParentHeader: consent.ParentHeader,
                    ConsentFooter: consent.ConsentFooter,
                    RequireName: consent.RequireName,
                    RequireEmail: consent.RequireEmail,
                    RequireAddress: consent.RequireAddress,
                    RequirePhone: consent.RequirePhone,
                    RequireNationality: consent.RequireNationality,
                    RequireGender: consent.RequireGender,
                    IncludedArtists: consent.IncludedArtists,
                    IncludedClauses: consent.IncludedClauses
                }),
            })
                .then(response => response.json())
                .then(data => {
                    return dispatch(addConsentsSuccess(JSON.parse(JSON.stringify(data))))
                })
                .catch(error => console.error(error));
        }

    };
}


//Makes an API call to the gateway which will read an consent with mongoDB_id that matches the one passed on the URL. API call
//will return the current record after the read so we will dispatch a store update with the new records.
export function readConsent(tenant,id) {
    return function (dispatch) {
        //!!!!!MAKE SURE YOU USE THE SINGULAR "CONSENT" endpoint for Adds!!!!!
        let tempURL = rest.consent + '/' + id;
        fetch(tempURL, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                // turn the JSON into a string then into an JS array
                return dispatch(readConsentSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}


//Makes an API call to the gateway which will delete the consent with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function deleteConsent(tenant,id) {
    return function (dispatch) {

        const timestamp = Date.now();
        const api_key = tenant.apiKeyCloudinary;
        const api_secret = tenant.apiSecretKeyCloudinary;
        const cloudURL = tenant.cloudinary_destory;
        //Read the customer first, grab the image public ids so we can delete them from cloudinary
        //!!!!!MAKE SURE YOU USE THE SINGULAR "CONSENT" endpoint for lookup!!!
        let tempURL = rest.consent + '/' + id;
        fetch(tempURL, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                const imagePublicID = data.TitleImagePublicId;
                if(imagePublicID !== "") {
                    //build a payload and hash it
                    let payload_to_sign = "public_id=" + imagePublicID + "&timestamp=" + timestamp + api_secret;
                    let sha1_hash = sha1(payload_to_sign);
                    fetch(cloudURL, {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json;charset=UTF-8'
                        }),
                        body: JSON.stringify({
                            api_key: api_key,
                            public_id: imagePublicID,
                            signature: sha1_hash,
                            timestamp: timestamp
                        }),
                    })
                        .then(response => response.json())
                        .then(data => {

                        })
                        .catch(error => console.error(error));
                }
            })
            .catch(error => console.error(error));
        //!!!!!MAKE SURE YOU USE THE SINGULAR "CONSENT" endpoint for Deletes!!!!!
        //NOW LETS DELETE IT!
        tempURL = rest.consent + '/' + id;
        fetch(tempURL, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                // turn the JSON into a string then into an JS array
                return dispatch(deleteConsentsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));

    };
}



// WEBPACK FOOTER //
// ./src/actions/consentActions.js